import { ToastrService } from 'ngx-toastr';
import { environment } from 'projects/mypay4-fe-cittadino/src/environments/environment';
import {
    ConfigurationService, CookieService, manageError, UserService
} from 'projects/mypay4-fe-common/src/public-api';

import { Component } from '@angular/core';
import {
  faFacebookSquare, faInstagramSquare, faTwitterSquare, faYoutubeSquare
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  iconPhone = faPhone;
  iconEnvelope = faEnvelope;

  iconFacebook = faFacebookSquare;
  iconInstagram = faInstagramSquare;
  iconYoutube = faYoutubeSquare;
  iconTwitter = faTwitterSquare;

  baseMyPAUrl: string;

  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    //@Inject(DOCUMENT) private dom: Document,
    conf: ConfigurationService,
  ) {
      this.baseMyPAUrl = conf.getProperty('baseMyPAUrl', environment);
  }

  showAppInfo(){
    this.userService.getAppInfoString().subscribe(appInfoString => {
      this.toastr.info(appInfoString, 'Versione applicazione',{
        disableTimeOut: true,
        enableHtml: true,
        tapToDismiss: false,
        toastClass: 'ngx-toastr toast-app-info',
      });
      return null;
    }, manageError('Errore recuperando i dati della versione', this.toastr) );
  }

  resetCookieConsent(){
    this.cookieService.resetCookieConsentBar();
  }

}
